import { IconAdd } from 'braid-design-system';

import { LightTag } from '#src/components/LightTag/LightTag.tsx';

export const AddFilterButton = ({ onClick }: { onClick: () => void }) => (
  <>
    <LightTag
      tone="secondary"
      onClick={onClick}
      icon={<IconAdd />}
      iconPosition="leading"
    >
      Add filter
    </LightTag>
  </>
);
